import useLocale from '../../../Hooks/use-locale';
import { Text } from '../../../SubComponents/Text';
import { useTheme } from 'styled-components/macro';
import useBookingShop from '../server-data/use-booking-shop';

const LastStepInfoWithData = () => {
  const { data: shop } = useBookingShop();
  const { languageAsEnum } = useLocale();
  const theme = useTheme();

  const lastStepInfo = shop?.bookingLocalizations?.lastStepInfo?.[languageAsEnum];

  if (!lastStepInfo) return null;

  return (
    <Text
      fontFamily={theme.fontLabel}
      renderWhiteSpace
      mb="4"
      dangerouslySetInnerHTML={{
        __html: lastStepInfo,
      }}
    />
  );
};

export default LastStepInfoWithData;
